import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\PostController::index
* @see app/Http/Controllers/Creator/PostController.php:29
* @route '/app/creator/posts'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/app/creator/posts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\PostController::index
* @see app/Http/Controllers/Creator/PostController.php:29
* @route '/app/creator/posts'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PostController::index
* @see app/Http/Controllers/Creator/PostController.php:29
* @route '/app/creator/posts'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PostController::index
* @see app/Http/Controllers/Creator/PostController.php:29
* @route '/app/creator/posts'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\PostController::index
* @see app/Http/Controllers/Creator/PostController.php:29
* @route '/app/creator/posts'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PostController::index
* @see app/Http/Controllers/Creator/PostController.php:29
* @route '/app/creator/posts'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PostController::index
* @see app/Http/Controllers/Creator/PostController.php:29
* @route '/app/creator/posts'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Creator\PostController::store
* @see app/Http/Controllers/Creator/PostController.php:65
* @route '/app/creator/posts'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/posts',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\PostController::store
* @see app/Http/Controllers/Creator/PostController.php:65
* @route '/app/creator/posts'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PostController::store
* @see app/Http/Controllers/Creator/PostController.php:65
* @route '/app/creator/posts'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PostController::store
* @see app/Http/Controllers/Creator/PostController.php:65
* @route '/app/creator/posts'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PostController::store
* @see app/Http/Controllers/Creator/PostController.php:65
* @route '/app/creator/posts'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Creator\PostController::update
* @see app/Http/Controllers/Creator/PostController.php:94
* @route '/app/creator/posts/{post}'
*/
export const update = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/app/creator/posts/{post}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Creator\PostController::update
* @see app/Http/Controllers/Creator/PostController.php:94
* @route '/app/creator/posts/{post}'
*/
update.url = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { post: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { post: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            post: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        post: typeof args.post === 'object'
        ? args.post.id
        : args.post,
    }

    return update.definition.url
            .replace('{post}', parsedArgs.post.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PostController::update
* @see app/Http/Controllers/Creator/PostController.php:94
* @route '/app/creator/posts/{post}'
*/
update.put = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Creator\PostController::update
* @see app/Http/Controllers/Creator/PostController.php:94
* @route '/app/creator/posts/{post}'
*/
const updateForm = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PostController::update
* @see app/Http/Controllers/Creator/PostController.php:94
* @route '/app/creator/posts/{post}'
*/
updateForm.put = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Creator\PostController::destroy
* @see app/Http/Controllers/Creator/PostController.php:140
* @route '/app/creator/posts/{post}'
*/
export const destroy = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/creator/posts/{post}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\PostController::destroy
* @see app/Http/Controllers/Creator/PostController.php:140
* @route '/app/creator/posts/{post}'
*/
destroy.url = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { post: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { post: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            post: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        post: typeof args.post === 'object'
        ? args.post.id
        : args.post,
    }

    return destroy.definition.url
            .replace('{post}', parsedArgs.post.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PostController::destroy
* @see app/Http/Controllers/Creator/PostController.php:140
* @route '/app/creator/posts/{post}'
*/
destroy.delete = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\PostController::destroy
* @see app/Http/Controllers/Creator/PostController.php:140
* @route '/app/creator/posts/{post}'
*/
const destroyForm = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PostController::destroy
* @see app/Http/Controllers/Creator/PostController.php:140
* @route '/app/creator/posts/{post}'
*/
destroyForm.delete = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Creator\PostController::unarchive
* @see app/Http/Controllers/Creator/PostController.php:170
* @route '/app/creator/posts/{post}/unarchive'
*/
export const unarchive = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unarchive.url(args, options),
    method: 'post',
})

unarchive.definition = {
    methods: ["post"],
    url: '/app/creator/posts/{post}/unarchive',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\PostController::unarchive
* @see app/Http/Controllers/Creator/PostController.php:170
* @route '/app/creator/posts/{post}/unarchive'
*/
unarchive.url = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { post: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { post: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            post: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        post: typeof args.post === 'object'
        ? args.post.id
        : args.post,
    }

    return unarchive.definition.url
            .replace('{post}', parsedArgs.post.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PostController::unarchive
* @see app/Http/Controllers/Creator/PostController.php:170
* @route '/app/creator/posts/{post}/unarchive'
*/
unarchive.post = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unarchive.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PostController::unarchive
* @see app/Http/Controllers/Creator/PostController.php:170
* @route '/app/creator/posts/{post}/unarchive'
*/
const unarchiveForm = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unarchive.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PostController::unarchive
* @see app/Http/Controllers/Creator/PostController.php:170
* @route '/app/creator/posts/{post}/unarchive'
*/
unarchiveForm.post = (args: { post: number | { id: number } } | [post: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unarchive.url(args, options),
    method: 'post',
})

unarchive.form = unarchiveForm

/**
* @see \App\Http\Controllers\Creator\PostController::uploadImage
* @see app/Http/Controllers/Creator/PostController.php:186
* @route '/app/creator/posts/upload-image'
*/
export const uploadImage = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: uploadImage.url(options),
    method: 'post',
})

uploadImage.definition = {
    methods: ["post"],
    url: '/app/creator/posts/upload-image',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\PostController::uploadImage
* @see app/Http/Controllers/Creator/PostController.php:186
* @route '/app/creator/posts/upload-image'
*/
uploadImage.url = (options?: RouteQueryOptions) => {
    return uploadImage.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PostController::uploadImage
* @see app/Http/Controllers/Creator/PostController.php:186
* @route '/app/creator/posts/upload-image'
*/
uploadImage.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: uploadImage.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PostController::uploadImage
* @see app/Http/Controllers/Creator/PostController.php:186
* @route '/app/creator/posts/upload-image'
*/
const uploadImageForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: uploadImage.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\PostController::uploadImage
* @see app/Http/Controllers/Creator/PostController.php:186
* @route '/app/creator/posts/upload-image'
*/
uploadImageForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: uploadImage.url(options),
    method: 'post',
})

uploadImage.form = uploadImageForm

const posts = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    unarchive: Object.assign(unarchive, unarchive),
    uploadImage: Object.assign(uploadImage, uploadImage),
}

export default posts